import mapboxgl from 'mapbox-gl';
import React, { useMemo } from 'react';
import ReactMapboxGl from 'react-mapbox-gl';

import { Config } from '../../../config';

// This fixes an issue with transpilation of mapbox

// https://github.com/alex3165/react-mapbox-gl/issues/931#issuecomment-763773368
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

export function MapBox(props: any) {
  const Factory = useMemo(() => ReactMapboxGl(
    {
      accessToken: Config.MapboxApiKey,
      keyboard: false,
      boxZoom: false
    }), [Config.MapboxApiKey]);

  return <Factory {...props} />;
}
